import { render } from "./DSelect.vue?vue&type=template&id=5b9ec630"
import script from "./DSelect.vue?vue&type=script&lang=ts"
export * from "./DSelect.vue?vue&type=script&lang=ts"
script.render = render

export default script